<template>
  <section>
    <div id="measurements" class="row">
      <!-- Search -->
      <div class="col-md-5 custom-title-wrap">
        <span class="custom-title">Measurements</span>
        <span class="custom-subtitle"
          >(use the radio buttons below to select a new initial
          measurement)</span
        >
      </div>
      <!-- Pagination -->
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-2">
            <z-select
              v-model="pageSize"
              :options="pageSizes"
              @change="changePageSize"
            />
          </div>
          <div class="col-md-6">
            <nav>
              <z-paginate
                v-model="page"
                :page-count="pages"
                @change="changePage"
              />
            </nav>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-2 custom-items">
            <span class="mt-2 mr-2 custom-items-value" title="# items">{{
              numItems
            }}</span>
            <span class="custom-items-label">items</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZSelect from '@/Components/ZElements/Select'
import ZPaginate from '@/Components/ZElements/Paginate'
export default {
  name: 'measurements-header',
  components: {
    ZSelect,
    ZPaginate,
  },
  props: {
    pageSizes: {
      type: Array,
      default: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 },
      ],
    },
  },
  emits: ['search', 'add'],
  data() {
    return {
      showTitle: true,
    }
  },
  computed: {
    ...mapGetters('bodycomposition', ['pager']),
    numItems() {
      let _items = 0
      if (this.pager) {
        _items = this.pager.total
      }
      return _items
    },
    pages() {
      let _pages = 1
      if (this.pager) {
        _pages = this.pager.pages ? this.pager.pages : 1
      }
      return _pages
    },
    pageSize: {
      get() {
        let _pageSize = 10
        if (this.pager) {
          _pageSize = this.pager.pageSize ? this.pager.pageSize : 10
        }
        return _pageSize
      },
      set(value) {
        this.page = 1
        this.setPager({
          name: 'pageSize',
          value: value,
        })
        this.setPager({
          name: 'page',
          value: 1,
        })
        this.setPager({
          name: 'search',
          value: '',
        })
      },
    },
    page: {
      get() {
        let _page = 1
        if (this.pager) {
          _page = this.pager.page ? this.pager.page : 1
        }
        return _page
      },
      set(value) {
        this.setPager({
          name: 'page',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('bodycomposition', ['setPager']),
    changePage() {
      this.$emit('search')
    },
    changePageSize() {
      this.$emit('search')
    },
    onSearch() {
      if (this.page > 1) {
        this.page = 1
      }
      this.$emit('search')
    },
    addMeasurement() {
      this.$emit('add')
    },
  },
}
</script>
<style scoped>
.custom-title-wrap {
  display: grid;
}
.custom-title {
  font-size: 1rem;
  font-weight: 400;
}
.custom-subtitle {
  font-size: 0.8em;
}
.custom-items {
  text-align: right;
}
.custom-items-value {
  font-size: 1rem;
  font-weight: 400;
}
.custom-items-label {
  font-size: 0.8rem;
  right: 25px;
  top: 20px;
  position: relative;
}
</style>